import React from "react";
import SingleCard from "../Reusable/SingleCard";
import {
  absentWoutLeave,
  onBoarding,
  lateLogging,
  attendance,
  noOfLeavesApproved,
  employeesLeft,
} from "../Reusable/CardData";

export default function DashboardStatsSection({
  leaveStats,
  employeeExitStats,
  attendanceStats,
  moveToEmployeeLeft,
  moveToLateLogins,
}) {
  return (
    <div className="flex flex-col h-full">
      <div className="grid grid-cols-2 gap-[10px] justify-between h-screen">
        {/* No. of Leaves Approved */}
        <div>
          <SingleCard
            item={{
              ...noOfLeavesApproved,
              count: leaveStats.totalApproved,
            }}
          />
        </div>

        {/* Absent without Leave */}
        <div>
          <SingleCard item={absentWoutLeave} />
        </div>

        {/* On Boarding */}
        <div>
          <SingleCard item={onBoarding} />
        </div>

        {/* Employees Left */}
        <div onClick={moveToEmployeeLeft}>
          <SingleCard
            item={{
              ...employeesLeft,
              count: employeeExitStats.count,
            }}
          />
        </div>

        {/* Attendance */}
        <div>
          <SingleCard
            item={{
              ...attendance,
              count: attendanceStats.totalPresent,
            }}
          />
        </div>

        {/* Late Logging */}
        <div onClick={moveToLateLogins}>
          <SingleCard
            item={{
              ...lateLogging,
              count: attendanceStats.numberOfLateLogins,
            }}
          />
        </div>
      </div>
    </div>
  );
}
